import { glDailyTransaction } from './transaction/index';
import { glReportHeadersTotalsTransaction } from './reportHeadingsTotals/index';
import { glCollateralBankTransaction } from './collateralBank/index';
import { saiMonthlyTransaction } from './saiMonthlyTransaction';
import { saiMonthlySummaryTransaction } from './saiMonthlySummary';
import { saiBankReconciliation } from './saiBankReconciliation';
import { saiBankCodes } from './saiBankCodes';
import { interestApportionment } from './interestApportionment';
import { glInvestmentTransaction } from './glInvestment/index';
import { checkODBalanceToGL } from './checkODBalToGL';
import { checkMISCBalanceToGL } from './checkMISCBalToGL';
import { checkMTGBalanceToGL } from './checkMTGBalToGL';
import { checkTaxPaymentBalanceToGL } from './checkTaxPaymentBalToGL';
import { checkWarrantBalanceToGL } from './checkWarrantBalToGL';
import { treasurersChecks } from './treasurersChecks';

export const glDaily = {
  namespaced: true,
  modules: {
    glDailyTransaction,
    glReportHeadersTotalsTransaction,
    glCollateralBankTransaction,
    saiMonthlyTransaction,
    saiMonthlySummaryTransaction,
    saiBankReconciliation,
    saiBankCodes,
    interestApportionment,
    checkODBalanceToGL,
    glInvestmentTransaction,
    checkMISCBalanceToGL,
    checkMTGBalanceToGL,
    checkTaxPaymentBalanceToGL,
    checkWarrantBalanceToGL,
    treasurersChecks,
  },
};

export default glDaily;
